import {home} from "./home";

export const m = {
    home
};
